export enum TokenRecoveryType {
  Email = 1,
  SMS = 2
}